import React, { Component } from "react";
import { observer } from "mobx-react";

import { ITags } from "@formant/core/model/ITags";

import { deviceStore } from "../../stores";
import { SelectTags } from "./SelectTags";

export interface ISelectDeviceTagsProps {
    value: ITags;
    includeNone?: boolean;
    excludeTagKeys?: string[];
    includeStarTag?: boolean;
    className?: string;
    onChange: (value: ITags) => void;
}

@observer
export class SelectDeviceTags extends Component<ISelectDeviceTagsProps> {
    public render() {
        const { excludeTagKeys, includeStarTag } = this.props;
        const tags =
            deviceStore.tags({
                enabled: true,
                type: "default",
            }) || {};
        if (includeStarTag) {
            Object.keys(tags).forEach(key => {
                if (!tags[key].includes("*")) {
                    tags[key].push("*");
                }
            });
        }

        const keys = Object.keys(tags).filter(
            _ => !excludeTagKeys?.includes(_),
        );

        return <SelectTags {...this.props} keys={keys} tags={tags} />;
    }
}
